import { TFunction } from 'i18next';

const CreditUsageListColumns = (t: TFunction) => [
  {
    name: t('CREDIT_USAGE_LIST_MODAL_NAME_TABLE'),
    width: '23%',
    sortField: 'Name',
    cell: (row: { name: string }) => {
      return <span className="text-capitalize table-text">{row.name}</span>;
    },
  },
  {
    name: t('CREDIT_USAGE_LIST_MODAL_AMOUNT_TABLE'),
    width: '14%',
    sortField: 'role',
    selector: (row: { amount: number; isRefund: boolean }) => row.amount,
    cell: (row: { amount: number; isRefund: boolean }) => (
      <span
        className="text-capitalize table-text"
        style={{ color: row.isRefund ? 'green' : 'red' }}
      >
        {row.amount}
      </span>
    ),
  },
  {
    name: t('CREDIT_USAGE_LIST_MODAL_FROM_DATE_TABLE'),
    width: '20%',
    sortField: 'role',
    selector: (row: { fromDate: number }) => row.fromDate,
    cell: (row: { fromDate: number }) => {
      return (
        <span className="text-capitalize table-text">
          {row.fromDate
            ? `${new Date(row.fromDate).toLocaleDateString()},
          ${new Date(row.fromDate).getHours()}:${
                new Date(row.fromDate).getMinutes() === 0
                  ? '00'
                  : new Date(row.fromDate).getMinutes()
              }`
            : ''}
        </span>
      );
    },
  },
  {
    name: t('CREDIT_USAGE_LIST_MODAL_TO_DATE_TABLE'),
    width: '20%',
    sortField: 'role',
    selector: (row: { toDate: number }) => row.toDate,
    cell: (row: { toDate: number }) => (
      <span className="text-capitalize table-text">
        {row.toDate
          ? `${new Date(row.toDate).toLocaleDateString()},
          ${new Date(row.toDate).getHours()}:${
              new Date(row.toDate).getMinutes() === 0
                ? '00'
                : new Date(row.toDate).getMinutes()
            }`
          : ''}
      </span>
    ),
  },
  {
    name: t('CREDIT_USAGE_LIST_MODAL_ORDERED_BY_TABLE'),
    sortable: true,
    width: '20%',
    sortField: 'role',
    selector: (row: { orderedBy: string }) => row.orderedBy,
    cell: (row: { orderedBy: { fullName: string } }) => (
      <span className="text-capitalize table-text">{row.orderedBy}</span>
    ),
  },
];

export default CreditUsageListColumns;
